import { Auth } from 'aws-amplify';
import React, { useEffect, useReducer } from 'react';

const AppContext = React.createContext();
const _appState = {
    currentView : "#athlete",
    showToast : false,
    toastMessage : "",
    messageType : "",
    user : {},
    userProfile : {},
    athleteInView : {}
};

function appReducer(state , {type , data}){
    switch (type) {
        case 'RESET_STATE':
            return{...state, ..._appState};
        case 'set_user':
            return{...state , user : data };
        case 'SET_CURRENT_VIEW':
            return {...state , currentView : data};
        case 'SET_PROFILE':
            return {...state , userProfile : data};
        case 'SET_ATHLETE_IN_VIEW':
            return {...state , athleteInView : data};
        case 'show_toast':
            return {...state, toastMessage : data.value ,messageType : data.messageType, showToast : true };
        case 'hide_toast':
            return {...state, toastMessage : "" ,messageType : "" , showToast : false };
        default:
            break;
    }
}
const AppProvider = ({ children }) => {
    const [appState, dispatch ] = useReducer(appReducer , _appState);
    useEffect(()=>{
        getUser();
        async function getUser(){
            try{
                const user = await Auth.currentAuthenticatedUser();
                const groups  = user.signInUserSession.accessToken.payload["cognito:groups"];
                return dispatch({ type : 'set_user' , data : {...user.attributes , groups}});
            }
            catch(err){
                console.log(err);
            }
        }
    },[]);
    async function getUser(){
        try{
            const user = await Auth.currentAuthenticatedUser();
            const  groups  = user.signInUserSession.accessToken.payload["cognito:groups"];
            return dispatch({ type : 'set_user' , data : {...user.attributes , groups}});
        }
        catch(err){
            console.log(err);
        }
    }
    function setUserProfile(data){
        return dispatch({ type : 'SET_PROFILE' , data});
    }
    function showAppToast(message,messageType){
        return dispatch({ type : 'show_toast' , data : { value : message , messageType }});
    }
    function hideAppToast(){
        return dispatch({ type : 'hide_toast'});
    }
    function setCurrentView(view){
        return dispatch({ type : 'SET_CURRENT_VIEW' , data : view});
    }
    function setAtheleteInView(athlete){
        return dispatch({type : 'SET_ATHLETE_IN_VIEW' , data : athlete});
    }
    function resetState(){
        return dispatch({type : 'RESET_STATE'});
    }
    return (
        <AppContext.Provider value={{ appState ,getUser, showAppToast , hideAppToast, resetState ,setCurrentView , setUserProfile ,setAtheleteInView}}>
            {children}
        </AppContext.Provider>
    );
};
export { AppContext , AppProvider};